/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Rehab_Ex_OneInputs */

const en_for_whom_rehab_ex_one = /** @type {(inputs: For_Whom_Rehab_Ex_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glute bridge`)
};

const pl_for_whom_rehab_ex_one = /** @type {(inputs: For_Whom_Rehab_Ex_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostek biodrowy`)
};

/**
* | output |
* | --- |
* | "Glute bridge" |
*
* @param {For_Whom_Rehab_Ex_OneInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_rehab_ex_one = /** @type {((inputs?: For_Whom_Rehab_Ex_OneInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Rehab_Ex_OneInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_rehab_ex_one(inputs)
	return en_for_whom_rehab_ex_one(inputs)
});